module.exports = __webpack_public_path__ + "static/media/ODS14.4fbf867c.svg";